import React, { FunctionComponent } from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import { ChatSelectedDocument } from "../../context/ChatContext";
import { colorGrayLight } from "../../styles/theme";

interface DocumentSelectionFooterProps {
	selectedDocuments: ChatSelectedDocument[];
	onRemoveDocument: (documentId: number) => void;
	onConfirm: () => void;
}

const DocumentSelectionFooter: FunctionComponent<
	DocumentSelectionFooterProps
> = ({ selectedDocuments, onRemoveDocument, onConfirm }) => {
	return (
		<Box
			sx={{
				padding: "12px 16px",
				borderTop: `1px solid ${colorGrayLight}`,
				display: "flex",
				flexDirection: "column",
				gap: "10px",
			}}
		>
			{selectedDocuments.length ? (
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						gap: "6px",
						maxHeight: "90px",
						overflowY: "auto",
					}}
				>
					{selectedDocuments.map((document) => (
						<Chip
							key={document.id}
							label={document.title}
							size="small"
							sx={{ maxWidth: "100%" }}
							onDelete={() => onRemoveDocument(document.id)}
						/>
					))}
				</Box>
			) : (
				<Typography variant="caption">No documents selected yet</Typography>
			)}
			<Button
				variant="contained"
				disabled={!selectedDocuments.length}
				onClick={onConfirm}
				sx={{ textTransform: "none" }}
			>
				Confirm
			</Button>
		</Box>
	);
};

export default DocumentSelectionFooter;
